import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {FormikContextType, useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SponsorBottomSheetProps} from '../type';
import SponsorCustomButton from '../../CustomButton';
import useGetCitiesSponsorInformation from '../../../../../services/hookService/sponsor/getCitySponsorInformation/useGetCitiesSponserInformation';
import { initialValuesSponsorForm } from '../../../CreateActivePlan/type';

const CityBottomSheet = ({show, setShow}: SponsorBottomSheetProps) => {
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();
  const allState = formikProps.values.state.map(item => item.id).join(`,`);
  const {cities, isLoading} = useGetCitiesSponsorInformation(allState);
  return (
    <BottomSheet
      onDismiss={() => setShow(false)}
      open={show}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
      className="custom-bottom-sheet"
    >
      <div className="p-6 flex flex-col gap-[29px] text-gray-900">
        {/* start header bottom sheet */}
        <div className="flex items-center justify-between ">
          <h5>شهرستان</h5>
          <SpanIcon
            className="icon-nameClose-remove text-gray-700 text-2xl"
            onClick={() => setShow(false)}
          />
        </div>
        {/* end header bottom sheet */}
        <ul className="space-y-2 overflow-y-scroll mb-0 pl-0 max-h-[60dvh]">
          {!isLoading &&
            cities &&
            cities.map((city, index) => {
              const isInArray = formikProps.values.city.some(
                item => item.id === city.id,
              );
              return (
                <li
                  className="flex items-center gap-1"
                  key={'sponser-message-item' + index}
                  onClick={() => {
                    if (isInArray) return;
                    const newData = [...formikProps.values.city];
                    newData.push({title: city.name, id: city.id});
                    formikProps.setFieldValue('city', newData);
                    formikProps.setFieldTouched('city', true);
                  }}
                >
                  <span
                    className={`w-3 h-3 !rounded !border ${
                      isInArray
                        ? 'bg-farm-shop-500 !border-farm-shop-500'
                        : 'bg-transparent !border-gray-800'
                    }`}
                  ></span>
                  <span>{city.name}</span>
                </li>
              );
            })}
        </ul>
        <div className="px-8">
          <SponsorCustomButton
            outline={false}
            buttonType="button"
            title="تأیید"
            handler={() => setShow(false)}
          />
        </div>
      </div>
    </BottomSheet>
  );
};
export default CityBottomSheet;
